import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GiftCard } from 'components/GiftCard';
import { Spinner } from 'components/Spinner';
import { Button, Typography } from '@clover/web-lib-consumer-ui';
import { Money } from 'components/Money';
import { GiftCardInputFields } from 'routes/GiftCard/Form/InputFields';
import { useMerchant } from 'hooks/context/merchant';

import { GiftCardFormValues } from '../model';

import styles from './styles.module.scss';

type TabletGiftCardFormProps = {
  value?: Partial<GiftCardFormValues>;
  onChange?: (values: GiftCardFormValues) => void;
  update?: boolean;
};

export const TabletGiftCardForm: FC<TabletGiftCardFormProps> = ({ value, onChange, update }) => {
  const { merchant, isLoading } = useMerchant();
  const { t } = useTranslation();

  if (!merchant || isLoading) {
    return <Spinner />;
  }

  const { name } = merchant;

  return (
    <section className={styles.container}>
      <div className={styles.col}>
        <Typography.Heading2 element="h2">{t('giftCards.digitalGiftCard')}</Typography.Heading2>
        <p>{t('giftCards.description', { merchantName: name })}</p>
        <GiftCardInputFields className={styles.fields} value={value} onChange={onChange} />
      </div>
      <div className={styles.col}>
        <div className={styles.sticky}>
          <GiftCard amount={value?.amount} />
          <Button className={styles.button} type="submit">
            {update ? t('updateOrder') : t('addToOrder')}
            {' • '}
            <Money amount={value?.amount} />
          </Button>
        </div>
      </div>
    </section>
  );
};
